export const ChevronDownIcon = () => (
  <svg className="mc-icon" xmlns="http://www.w3.org/2000/svg" width="31px" height="10px" viewBox="0 0 31 10">
    <path
      fill="#fff"
      d="M15.5,10L0.492,0.632l1.015-0.633L15.5,8.734l13.993-8.735l1.014,0.633L16.514,9.367h0L15.5,10z"
    />
  </svg>
);
